import { render, staticRenderFns } from "./downloadOrder.vue?vue&type=template&id=32f12ffe&scoped=true&"
import script from "./downloadOrder.vue?vue&type=script&lang=js&"
export * from "./downloadOrder.vue?vue&type=script&lang=js&"
import style0 from "./downloadOrder.vue?vue&type=style&index=0&id=32f12ffe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!C:\\Users\\86177\\AppData\\Roaming\\npm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f12ffe",
  null
  
)

export default component.exports